<template>
  <div class="asc-info-label">
    <v-icon
      v-if="!hideIcon"
      :color="getIconColor"
      :size="getIconSize"
      class="asc-info-label--icon"
    >
      {{ getIcon }}
    </v-icon>
    <asc-label
      class="asc-info-label--text"
      :size="labelSize"
      :value="value"
    ></asc-label>
  </div>
</template>

<script>
import AscLabel from '@/components/atoms/AscLabel'
import variables from '@/styles/_varsJs.scss'

export default {
  name: 'AscInfoLabel',
  components: {
    AscLabel,
  },
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'info',
    },
    value: {
      type: String,
      default: '',
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getIcon() {
      return this.type === 'info' ? 'mdi-information' : 'mdi-alert'
    },
    getIconColor() {
      return this.type === 'info'
        ? variables.primaryblack
        : variables.cautionbase
    },
    getIconSize() {
      return this.small ? '12' : '18'
    },
    labelSize() {
      return this.small ? 'sm' : null
    },
  },
}
</script>

<style lang="scss">
.asc-info-label {
  display: flex;

  &--icon {
    margin-right: 8px;
  }
}
</style>
